

























import { Vue, Component } from "vue-property-decorator";
import { EnrollmentOrder as IEnrollmentOrder } from "@/api/models/enrollment-order";
import EnrollmentOrderFormEdit from "@/components/enrollment/EnrollmentOrderFormEdit.vue";
import api from "@/getinfo-api";
import CBreadCrumbs from "@/components/form/CustomPage/CBreadCrumbs.vue";

@Component({
  components: {
    CBreadCrumbs,
    EnrollmentOrderFormEdit
  }
})
export default class enrollmentOrderEdit extends Vue {
  enrollmentData!: IEnrollmentOrder;

  data() {
    return {
      enrollmentData: undefined
    };
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "enrollmentList" },
        label: this.$tc(this.$translate.OrdersOfEnrollment)
      },
      {
        to: {
          name: "enrollmentOrder",
          params: { enrollmentId: this.enrollmentData.id }
        },
        label: this.enrollmentData.number
      },
      {
        label: this.$tc(this.$translate.Edit)
      }
    ];
  }

  getEnrollmentData() {
    api.EnrollmentOrderApi.get(this.$route.params.enrollmentId).then(
      (res: { data: IEnrollmentOrder }) => {
        this.enrollmentData = res.data;
      }
    );
  }

  mounted() {
    this.getEnrollmentData();
  }
}
